module.exports = __webpack_public_path__ + "static/media/img2-2.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/B/img2-2.png
// module id = 2123
// module chunks = 3